module.exports = __webpack_public_path__ + "media/images/astroboy-b20c706a54bdabce1827635af589ea5f.svg";